function initTooltips() {
    $("[data-toggle=tooltip").tooltip();
}

document.addEventListener("DOMContentLoaded", initTooltips);